exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3ngeuSDNiNMAey65xzySK-{color:var(--card-neutralSecondary)}._2wyD-ii8U1_D8Y2NGSWMZ2{color:var(--card-dueDateRed)}.AaMk0X9wTCEaz1IHOkYXq{color:var(--card-dueDateGreen)}", ""]);
// Exports
exports.locals = {
	"future": "_3ngeuSDNiNMAey65xzySK-",
	"todayAndPast": "_2wyD-ii8U1_D8Y2NGSWMZ2",
	"completed": "AaMk0X9wTCEaz1IHOkYXq"
};